import "core-js/modules/es6.regexp.split";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/gva_web/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import { getTableauView } from "@/api/tableau";
export default {
  name: "reportcardDetail",
  data: function data() {
    return {
      url: "",
      backurl: "",
      token: "",
      clientWidth: 1500,
      reloadIframe: true,
      clientHeight: '',
      card: {}
    };
  },
  mounted: function mounted() {
    this.urlList = [];
    this.mounturl();
  },
  methods: {
    /**请求后端生成tableau的url */tableauView: function () {
      var _tableauView = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(card) {
        var res;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 1;
              return getTableauView(card);
            case 1:
              res = _context.sent;
              return _context.abrupt("return", res);
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function tableauView(_x) {
        return _tableauView.apply(this, arguments);
      }
      return tableauView;
    }(),
    /**渲染函数 */mounturl: function () {
      var _mounturl = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var getqyinfo, getqys, dealerParam, res, url;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.backurl = window.atob(this.$route.params.body);
              console.log("backurl:", this.backurl);
              /**解析url开头是tableau则重新请求tableau view */
              if (!(this.backurl.substr(0, 7) == 'tableau')) {
                _context2.next = 2;
                break;
              }
              getqyinfo = this.backurl.split('?')[1];
              getqys = new URLSearchParams('?' + getqyinfo);
              this.card.wgserver = getqys.get('wgserver');
              this.card.remoteAddr = getqys.get('remoteAddr');
              this.card.username = getqys.get('username');
              this.card.view = getqys.get('view');
              this.card.tabType = getqys.get('tabType');
              dealerParam = getqys.get('DP_Dealer');
              _context2.next = 1;
              return this.tableauView(this.card);
            case 1:
              res = _context2.sent;
              url = res.data.url + "&t=" + new Date().getTime() + "&DP_Dealer=" + dealerParam;
              this.url = url;
              _context2.next = 3;
              break;
            case 2:
              this.url = this.backurl;
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function mounturl() {
        return _mounturl.apply(this, arguments);
      }
      return mounturl;
    }() // /**渲染函数 */
    // async mounturl() {
    //   this.backurl = window.atob(this.$route.params.body);
    //   console.log("backurl:",this.backurl)
    //   /**解析url开头是tableau则重新请求tableau view */
    //   if(this.backurl.substr(0,7) == 'tableau') {
    //     let getqyinfo = this.backurl.split('?')[1];
    //     let getqys = new URLSearchParams('?' + getqyinfo);
    //     this.card.wgserver = getqys.get('wgserver');
    //     this.card.remoteAddr = getqys.get('remoteAddr');
    //     this.card.username = getqys.get('username');
    //     this.card.view = getqys.get('view');
    //     this.card.tabType = getqys.get('tabType');
    //     if(getqys.get('filterKey') != null){
    //       console.log('filterKey => ' + getqys.get('filterKey'));
    //       this.card.filterKey = getqys.get('filterKey');
    //     }
    //     if(getqys.get('filterName') != null){
    //       console.log('filterName => ' + getqys.get('filterName'));
    //       this.card.filterName = getqys.get('filterName');
    //     }
    //     let res = await this.tableauView(this.card);
    //     const url = res.data.url + "&t=" + new Date().getTime() +"&" + getqys.get('filterKey') + "=" + encodeURIComponent(getqys.get('filterName'));
    //     this.url = url;
    //   } else {
    //     this.url = this.backurl;
    //   }
    // }
  },
  watch: {
    $route: {
      handler: function handler() {
        this.mounturl();
      },
      deep: true
    }
  }
};